import { render } from "./slide6.vue?vue&type=template&id=021814c5&scoped=true"
import script from "./slide6.vue?vue&type=script&lang=js"
export * from "./slide6.vue?vue&type=script&lang=js"

import "./slide6.vue?vue&type=style&index=0&id=021814c5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021814c5"]])

export default __exports__